import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Lock, ShieldCheck } from 'lucide-react';
export function Pricing() {
  return <Section id="pricing" dark className="bg-navy relative overflow-hidden" data-id="element-103">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-104"></div>
      <div className="absolute -top-40 -right-40 w-80 h-80 bg-gold/5 rounded-full blur-3xl" data-id="element-105"></div>
      <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gold/5 rounded-full blur-3xl" data-id="element-106"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-107">
        <h2 className="text-3xl md:text-4xl font-serif mb-6 text-cream" data-id="element-108">
          Tu Segundo Acto Comienza Aquí
        </h2>

        <p className="text-lg text-cream-dark/80 font-light mb-12 max-w-2xl mx-auto" data-id="element-109">
          Obtén acceso inmediato al sistema completo que transformará tu
          presencia digital de "invisible" a "irresistible". Todo lo que
          necesitas para dominar TikTok con elegancia por una fracción de lo que
          costaría una sola sesión de consultoría de imagen.
        </p>

        <div className="bg-navy-light border border-gold/30 p-8 md:p-12 rounded-sm shadow-2xl relative" data-id="element-110">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-navy text-xs font-bold uppercase tracking-widest py-1 px-4 rounded-full" data-id="element-111">
            Oferta Especial
          </div>

          <div className="mb-8" data-id="element-112">
            <span className="text-5xl md:text-6xl font-serif text-cream" data-id="element-113">
              $6.39
            </span>
            <span className="text-xl text-gold-light ml-2" data-id="element-114">USD</span>
          </div>

          <Button href="https://explorarutina.com/cart/55492790812840:1" className="w-full md:w-auto text-sm md:text-base px-8 py-5 mb-6" data-id="element-115">
            Quiero empezar mi segundo acto ahora
          </Button>

          <div className="flex flex-col md:flex-row items-center justify-center space-y-3 md:space-y-0 md:space-x-6 text-sm text-cream-dark/60 font-light mt-6" data-id="element-116">
            <div className="flex items-center" data-id="element-117">
              <Lock className="w-4 h-4 mr-2 text-gold/70" data-id="element-118" />
              Pago 100% seguro
            </div>
            <div className="flex items-center" data-id="element-119">
              <ShieldCheck className="w-4 h-4 mr-2 text-gold/70" data-id="element-120" />
              Descarga instantánea
            </div>
          </div>
        </div>

        <p className="mt-12 text-cream-dark/50 text-sm font-light italic" data-id="element-121">
          Únete a las mujeres que están liderando la nueva autoridad digital.
        </p>
      </div>
    </Section>;
}